import { createSelector } from 'reselect';

const selectPlanosAcaoState = (state) => state.planosAcao;

export const makeSelectPlanosAcaoByIdProcessoAndIdUnidadeGerencia = (
    idProcesso,
    idUnidadeGerencia) =>
    createSelector(
        [selectPlanosAcaoState],
        (planosAcao) => {
            const key = `${idProcesso}-${idUnidadeGerencia}`;
            return planosAcao[key] || []; // Will return the same array unless value changes
        });
